import { Quote } from "lucide-react";

export const TEMOIGNAGES = [
  { nom: "Dr Jean-Marc Koffi", specialite: "Médecin généraliste · Abidjan", photo: "/images/temoignages/medecin-1.jpg",
    texte: "Entre l'admission et l'ordonnance, je gagne près d'une heure par jour. Mes patients repartent avec un compte rendu propre, et je retrouve n'importe quel dossier en trois secondes depuis la tablette." },
  { nom: "Dr Aminata Diallo", specialite: "Pédiatre · Bouaké", photo: "/images/temoignages/medecin-2.jpg",
    texte: "Ma secrétaire gère les admissions pendant que je consulte : les trois licences suffisent largement pour un petit cabinet. Le support a répondu en moins d'une heure la seule fois où j'en ai eu besoin." },
  { nom: "Dr Souleymane Traoré", specialite: "Gynécologue-obstétricien · Yamoussoukro", photo: "/images/temoignages/medecin-3.jpg",
    texte: "Les prescriptions numériques et les renouvellements en un clic ont changé mon quotidien. Le prix tout compris, tablette incluse, rend la solution accessible à un cabinet qui démarre." },
];

export function Temoignages({ items = TEMOIGNAGES, sousTitre = "Des praticiens témoignent." }) {
  return (
    <section className="bg-white" data-testid="cabinet-temoignages">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <h2 className="font-display text-base font-bold uppercase tracking-wider text-[#0369A1] md:text-lg">Ils l'utilisent au quotidien</h2>
        <p className="mt-2 text-sm text-slate-600">{sousTitre}</p>
        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {items.map((t, i) => (
            <figure key={t.nom} className="flex flex-col rounded-2xl border border-[#7DC4E8] bg-[#F8FBFE] p-6" data-testid={`temoignage-${i + 1}`}>
              <Quote size={22} className="text-[#7DC4E8]" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-slate-700">« {t.texte} »</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img src={t.photo} alt={t.nom} className="h-14 w-14 rounded-full border-2 border-white object-cover shadow-sm" />
                <div>
                  <p className="text-sm font-semibold text-navy">{t.nom}</p>
                  <p className="text-xs text-[#0369A1]">{t.specialite}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
